/*! @pentacode/ui v0.1.0 */
import { t as e } from "./decorateMetadata-BhwOl-pv.js";
import { t } from "./decorate-DHgd5sZx.js";
import "lit";
import { property as n } from "lit/decorators.js";
//#region src/composeSheet.ts
function r(e, t) {
	let n = new ((t?.defaultView?.CSSStyleSheet) ?? CSSStyleSheet)();
	return n.replaceSync(e), n;
}
function i(e) {
	return Array.from(e.cssRules).map((e) => e.cssText).join("\n");
}
function a(e) {
	return e ? [e].flat().map((e) => e instanceof CSSStyleSheet ? i(e) : e.toString()).join("\n") : "";
}
var o = /* @__PURE__ */ new WeakMap();
function s(e, t) {
	let n = t.defaultView;
	if (!n || e instanceof n.CSSStyleSheet) return e;
	let a = o.get(t);
	a || (a = /* @__PURE__ */ new WeakMap(), o.set(t, a));
	let s = a.get(e);
	return s || (s = r(i(e), t), a.set(e, s)), s;
}
function c(e, t) {
	return e ? [e].flat().map((e) => e instanceof CSSStyleSheet ? s(e, t) : r(e.toString(), t)) : [];
}
//#endregion
//#region src/styles/uno.css?url
var l = "/styles/uno.css", u;
function d(e, t) {
	fetch(t + (t.includes("?") ? "&" : "?") + "direct").then((e) => e.ok ? e : Promise.reject(/* @__PURE__ */ Error(`${e.status} ${e.statusText}`))).then((e) => {
		if (e.headers.get("content-type")?.includes("javascript")) throw Error("received a JS module instead of a stylesheet");
		return e.text();
	}).then((t) => {
		if (e.replaceSync(t), !e.cssRules.length) throw Error("no css rules");
	}).catch((e) => console.warn(`[@pentacode/ui] no utility styles: ${t} could not be loaded (${e}). Call provideUtilitySheet() from the app entry.`));
}
function f() {
	if (!u) {
		let e = new CSSStyleSheet();
		u = e, d(e, l);
	}
	return u;
}
function p(e) {
	u = e;
}
//#endregion
//#region src/elements/styledElement.ts
var m = (r) => {
	class i extends r {
		connectedCallback() {
			super.connectedCallback(), this.processStyles();
		}
		processStyles() {
			let e = this.ownerDocument, t = s(f(), e);
			if (this.renderRoot instanceof ShadowRoot) try {
				this.renderRoot.adoptedStyleSheets = [t, ...c(this.styles, e)];
			} catch {}
			else if (e.adoptedStyleSheets.includes(t) || (e.adoptedStyleSheets = [...e.adoptedStyleSheets, t]), this.styles) {
				let t = e.createElement("style");
				t.textContent = a(this.styles), this.renderRoot.appendChild(t);
			}
		}
	}
	return t([n({ attribute: !1 }), e("design:type", Object)], i.prototype, "styles", void 0), i;
};
//#endregion
export { c as a, s as i, f as n, p as r, m as t };

//# sourceMappingURL=styledElement-Dm1irIE2.js.map